// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"styles_profileWrapper__1CmtW","titleText":"styles_titleText__212OU","signUpForm":"styles_signUpForm__Am5B0"};